import { Badge } from '@/components/ui/badge';

interface OrderStatusBadgeProps {
  status: string;
}

const statusConfig: Record<string, { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' }> = {
  pending: { label: 'Pending', variant: 'outline' },
  assigned: { label: 'New Order', variant: 'default' },
  accepted: { label: 'Accepted', variant: 'secondary' },
  in_progress: { label: 'In Progress', variant: 'secondary' },
  delivered: { label: 'Delivered', variant: 'default' },
  cancelled: { label: 'Cancelled', variant: 'destructive' },
};

export const OrderStatusBadge = ({ status }: OrderStatusBadgeProps) => {
  const config = statusConfig[status] || { label: status, variant: 'outline' as const };
  
  return (
    <Badge variant={config.variant} className={status === 'delivered' ? 'bg-green-600' : ''}>
      {config.label}
    </Badge>
  );
};
